import Home from '../component/Home.vue'
// import Footer from '../component/Footer.vue'

import Active from '../component/active/Active.vue'
const routers = [
 	{
        path: '/',
        component: Home
    } ,
   {
        path: '/active/:province',
        component: Active
    } ,
    { path: '*', redirect: '/' }
];
export default routers;


// WEBPACK FOOTER //
// ./src/router/router.js